import React, { forwardRef } from 'react';
import { Column } from 'primereact/column';
import { Messages } from 'primereact/messages';
import { DataTable } from 'primereact/datatable';
import { ModalDialog } from '../../../components/ModalDialog';
import { ButtonAdd, ButtonDownload } from '../../../components/Buttons';
import { BackupTrigger } from '../../../constants/enums';

export const BackupDialog = forwardRef(({
    isVisible,
    onHide,
    onClickDownloadBackup,
    onClickCreateBackup,
    database,
    backups,
    msgs
}, ref) => {

    const backupTriggerTemplate = (rowData) => {
        switch(rowData.backup_trigger) {
            case BackupTrigger.MANUAL:
                return 'manuální záloha';
            case BackupTrigger.DELETION:
                return 'záloha před smazáním';
            case BackupTrigger.IMPORT:
                return 'záloha před importem';
        }

        return null;
    }

    const downloadButtonTemplate = (rowData) => {
        return (
            <ButtonDownload
                rounded
                title='Stáhnout zálohu'
                onClick={() => onClickDownloadBackup(rowData)}
            />
        );
    };

    return (
        <ModalDialog
            visible={isVisible}
            onHide={onHide}
            header={database ? `Zálohy databáze ${database.name}` : `Zálohy databáze`}
            footer={!database || database.deleted ? null : <ButtonAdd label='Vytvořit zálohu' type='button' onClick={onClickCreateBackup} />}
        >

            <Messages ref={msgs} className='flex-center' />

            <DataTable
                value={backups?.slice().reverse()}
                stripedRows
                paginator
                rows={5}
                rowsPerPageOptions={[5, 10, 20]}
                size='small'
                style={{ width: 600 }}
                emptyMessage='Nenalezeny žádné zálohy'
            >
                <Column field='backup_timestamp' header='Datum zálohy' bodyClassName='break-word' sortable />
                <Column field='backup_trigger' header='Spouštěč zálohy' body={backupTriggerTemplate} bodyClassName='break-word' />
                <Column field='download_button' body={downloadButtonTemplate} align='right' />
            </DataTable>
        </ModalDialog>
    );
});
